module.exports = __webpack_public_path__ + "media/Loop.cbb931f2.mp4";